import Result from '@/modules/core/models/result.class'

import * as ApiConstants from '../constants/auth-api-constants'
import type LoginResponseDTO from '../dtos/login-response.dto'
import type { Login } from '../models/auth.model'
import { mapLoginResponseFromLoginResponseDTO } from '../mappers/auth.mapper'
import type { VerifyOtpRequestDTO } from '../dtos/verify-otp-request.dto'
import { starsaversApi } from '@/modules/core/services/api/starsavers-api.service.ts'
import type { ObjectResponse } from '@/modules/core/interfaces/api-response.interfaces.ts'
import { BaseApiService } from '@/modules/core/services/api/base-api.service.ts'

export default class AuthApiService extends BaseApiService {
  async login(login: Login) {
    try {
      const response = await starsaversApi.post<ObjectResponse<LoginResponseDTO>>(
        ApiConstants.LOGIN_ENDPOINT,
        login
      )

      if (response.status) {
        return Result.success(mapLoginResponseFromLoginResponseDTO(response.data!))
      } else {
        return Result.failure(new Error(response.message || 'An unknown error occurred'))
      }
    } catch (error) {
      return this.handleApiError(error)
    }
  }

  async verifyOtp(verifyOtpRequest: VerifyOtpRequestDTO) {
    try {
      const response = await starsaversApi.post<ObjectResponse<null>>(
        '/otp/verify',
        verifyOtpRequest
      )

      if (response.status) {
        return Result.success(true)
      } else {
        return Result.failure(new Error(response.message || 'Verification failed'))
      }
    } catch (error) {
      return this.handleApiError(error)
    }
  }
}
